export {default} from './EditCandidateNotes.connect';
